import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Image,
  Popconfirm,
  message,
  Card,
  Tag,
  Modal,
  Descriptions,
  Layout,
  Select,
  Typography
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";
import axios from "axios";
import ErrorPopup from "../Components/popup/ErrorPopup";
import SuccessPopup from "../Components/popup/SuccessPopup";
import PromotionPopup from "../Components/popup/PromotionPopup/PromotionPopup";
import { MenuOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;
const { Option } = Select;
const { Text } = Typography;

const MyVariations = () => {
  const [data, setData] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewData, setViewData] = useState(null);

  const [promotionOpen, setPromotionOpen] = useState(false);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchVariations();
  }, []);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const fetchVariations = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/uservariations`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data.variations || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (variationId) => {
    try {
      setViewModalOpen(true);
      setViewData(null);

      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/uservariations/${variationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setViewData(res.data.variation);
    } catch (err) {
      message.error("Failed to load variation details");
      setViewModalOpen(false);
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/uservariations/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      setSuccessPopup(true);
      fetchVariations();
    } catch {
      setErrorPopup(true);
    }
  };

  const handlePayment = async (variation) => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/payment/create-order`,
        { variationId: variation._id, amount: 20 },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const { orderId, amount, key } = res.data.data;

      const options = {
        key,
        amount,
        currency: "INR",
        name: "YogaRefer.com",
        description: "Variation Renewal",
        order_id: orderId,
        handler: async (response) => {
          await axios.post(
            `${BASE_URL}/payment/verify`,
            {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              variationId: variation._id,
            },
            { headers: { Authorization: `Bearer ${token}` } },
          );

          message.success("Payment successful");
          fetchVariations();
        },
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
    } catch {
      message.error("Payment failed");
    }
  };

  const openPromotion = (record) => {
    setSelectedVariation(record);
    setPromotionOpen(true);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (img) => (
        <Image
          src={img}
          width={70}
          height={70}
          style={{ borderRadius: 8, objectFit: "cover" }}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Pose Type",
      dataIndex: "poseType",
      render: (types) =>
        types?.map((t) => (
          <Tag key={t} color="blue">
            {t}
          </Tag>
        )),
    },
    {
      title: "Status",

      render: (_, record) =>
        record.status === "pending" ? (
          <Tag color="orange" icon={<LoadingOutlined />}>
            Pending
          </Tag>
        ) : record.status === "rejected" ? (
          <Tag color="red" icon={<CloseCircleFilled />}>
            Rejected
          </Tag>
        ) : (
          <Tag color="green" icon={<CheckCircleFilled />}>
            Approved
          </Tag>
        ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            onClick={() => handleView(record._id)}
          />
          <Button
            icon={<EditOutlined />}
            type="primary"
            onClick={() => navigate(`/user/edit-variation/${record._id}`)}
          />
          <Popconfirm
            title="Delete this variation?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
    {
      title: "Media Link",
      dataIndex: "mediaLinkStatus",
      render: (status) => (
        <Tag color={status === "active" ? "green" : "orange"}>{status}</Tag>
      ),
    },
    {
      title: "Status",
      render: (_, record) =>
        record.mediaLinkAction === "none" ? (
          <Tag color="green">Free Trial</Tag>
        ) : record?.mediaLinkAction === "completed" ||
          record?.paymentStatus === "paid" ? (
          <Tag color="green">Renewal</Tag>
        ) : (
          <Space>
            <Button type="primary" onClick={() => handlePayment(record)}>
              Pay
            </Button>
            <Button onClick={() => openPromotion(record)}>Promote</Button>
          </Space>
        ),
    },
  ];

  const MobileVariationCard = ({ record }) => {
    const isFreeTrial = record.mediaLinkAction === "none";

    const isRenewal =
      record.mediaLinkAction === "completed" ||
      record.paymentStatus === "paid";

    const showPayPromote =
      !isFreeTrial && !isRenewal;

    return (
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: 14 }}
      >
        {/* Top */}
        <div style={{ display: "flex", gap: 12 }}>

          <Image
            src={record.image}
            width={70}
            height={70}
            style={{
              borderRadius: 10,
              objectFit: "cover",
            }}
          />

          <div style={{ flex: 1 }}>

            {/* Name + Approved */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>

              <div style={{
                fontWeight: 600,
                fontSize: 16,
              }}>
                {record.name}
              </div>

              <Tag color="green">
                {record.status}
              </Tag>

            </div>


            {/* Pose */}
            <div style={{
              fontSize: 13,
              color: "#777",
            }}>
              {record.poseType?.join(", ")}
            </div>


            {/* expired */}
            <div style={{ marginTop: 6 }}>

              <Tag color="blue">
                {record.mediaLinkStatus}
              </Tag>

            </div>

          </div>

        </div>


        {/* Pay / Promote Status */}
        <div style={{ marginTop: 10 }}>

          {isFreeTrial && (

            <Tag color="green">
              Free Trial
            </Tag>

          )}

          {isRenewal && (

            <Tag color="purple">
              Renewal
            </Tag>

          )}

          {showPayPromote && (

            <Space>

              <Button
                type="primary"
                onClick={() => handlePayment(record)}
              >
                Pay
              </Button>

              <Button
                onClick={() => openPromotion(record)}
              >
                Promote
              </Button>

            </Space>

          )}

        </div>


        {/* Actions */}
        <div
          style={{
            marginTop: 14,
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >

          <Button
            icon={<EyeOutlined />}
            onClick={() => handleView(record._id)}
          />

          <Button
            icon={<EditOutlined />}
            onClick={() =>
              navigate(`/user/edit-variation/${record._id}`)
            }
          />

          <Popconfirm
            title="Delete?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>

        </div>

      </Card>
    );
  };
  return (
    <div >
      <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          isMobile={isMobile}
          collapsedWidth="0"
          role="user"
        />
        <Layout
          className="main-layout"
          style={{
            marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
            transition: "0.3s",
            padding: isMobile ? 10 : 20,
          }}
        >
          <Header
            className="MainHeader"
          >
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setMobileOpen(true)}
                style={{ fontSize: 18, marginRight: 12 }}
              />
            )}
            <div style={{ flex: 1 }}>
              <Text style={{ fontSize: 20, fontWeight: "bold" }}>My Variations</Text>
            </div>
          </Header>

          <Card style={{ width: "100%" }}>
            {
              isMobile ? (

                data.map((record) => (
                  <MobileVariationCard
                    key={record._id}
                    record={record}
                  />
                ))

              ) : (

                <Table
                  columns={columns}
                  dataSource={data}
                  rowKey="_id"
                />

              )
            }
          </Card>

          <Modal
            title="Variation Details"
            open={viewModalOpen}
            onCancel={() => setViewModalOpen(false)}
            footer={null}
            width={900}
            centered
          >
            {viewData && (
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Name">
                  {viewData.name}
                </Descriptions.Item>
                <Descriptions.Item label="Sanskrit">
                  {viewData.sanskrit}
                </Descriptions.Item>
                <Descriptions.Item label="English">
                  {viewData.english}
                </Descriptions.Item>
                <Descriptions.Item label="Pose Type">
                  {viewData.poseType?.join(", ")}
                </Descriptions.Item>
                <Descriptions.Item label="Media Link">
                  <a href={viewData.mediaLink} target="_blank" rel="noreferrer">
                    {viewData.mediaLink}
                  </a>
                </Descriptions.Item>
                <Descriptions.Item label="Image">
                  <Image src={viewData.image} width={260} />
                </Descriptions.Item>
              </Descriptions>
            )}
          </Modal>
        </Layout>
      </Layout>

      <PromotionPopup
        open={promotionOpen}
        onClose={() => setPromotionOpen(false)}
        variation={selectedVariation}
      />

      <SuccessPopup
        open={successPopup}
        message="Variation deleted successfully!"
        onClose={() => setSuccessPopup(false)}
      />

      <ErrorPopup
        open={errorPopup}
        setOpen={setErrorPopup}
        message="Variation delete failed"
      />
    </div>
  );
};

export default MyVariations;
